import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';

@Injectable({
	providedIn: 'root'
})
export class NumberBinaryQualifierService implements Qualifier {
	static supportedStats = ['avg', 'count', 'first', 'last', 'max', 'median', 'min', 'sum', 'stddev'];
	static ToString(value: number, format: CastingTypeFormat): string {
		if (value === undefined) {
			return '';
		}
		let grouping = 8;
		switch (format) {
			case 'binary':
				return value.toString(2);
			case 'binary-c':
				return '0b' + value.toString(2);
			case 'binary-bytes':
				grouping = 8;
				break;
			case 'binary-nibbles':
				grouping = 4;
				break;
			case 'binary-tribble':
				grouping = 3
				break;
			case 'binary-crumb':
				grouping = 2
				break;
		}
		return value.toString(2).split('').reverse().join('').split(/(\d{4})/).filter((val) => {
			return val === '' ? false : true;
		}).join(' ').split('').reverse().join('').trim();
	}
	static FromString(value: string, format: CastingTypeFormat): number {
		if (value === '') {
			return 0;
		}
		switch (format) {
			case 'binary':
				return parseInt(value, 2);
			case 'binary-c':
				return parseInt(value.split('b').pop(), 2);
			default:
			case 'binary-bytes':
			case 'binary-nibbles':
			case 'binary-tribble':
			case 'binary-crumb':
				return parseInt(value.split(' ').join(''), 2);
		}
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return NumberBinaryQualifierService.ToString(val, casting.format);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if([undefined,null].indexOf(val) > -1) {
			return '';
		}
		return NumberBinaryQualifierService.GetDisplayValue(attribute, castingMode, val);
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		return NumberBinaryQualifierService.FromString(value, attribute.casting[castingMode].format);
	}
	public static SupportsStat(statName): boolean {
		return NumberBinaryQualifierService.supportedStats.indexOf(statName) > -1;
	}
	constructor() { }
	public static GetNumFormat():string {
		return '@';
	}
}
